/* src/app/shared/components/month-selector/month-selector.component.scss */
.month-selector-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 12px;
}
.month-selector-container .icon {
  font-size: 2vh;
}
.month-selector-container .month-year {
  font-size: large;
  font-weight: bold;
}
/*# sourceMappingURL=month-selector.component.css.map */
